/* tslint:disable:max-line-length */

import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const es: DeepPartial<Messages> = {
  custom: {
    clearSearchInput: 'Borrar texto',
    filters: 'Filtros:',
  },
  results: {
    addToCart: 'Añadir'
  },
  search: {
    inputPlaceholderAlternativesHTML: [
      'Busca por nombre...',
      'Busca por autor...',
      'Busca por temática...',
      'Busca por palabra clave...',
      'Busca por ISBN...'
    ]
  },
  sort: {
    titleHTML: '<span class="ebx-dropdown__toggle-title">Ordenar por</span><span class="ebx-dropdown__toggle-selected">{selectedItem}</span>'
  }
};
